import * as qrCode from 'easyqrcodejs'

export default function downloadQrCode (width, height) {
  console.log(width, height)
  return {
    methods: {
      async downloadQrCode() {
        try {  
          if (!this.qrCodePrintDrawn) {
            this.qrCodePrintDrawn = new qrCode(this.$refs.qrcode_print, {
              text: this.table.shortUrl,
              width,
              height,
              quietZone: 0,
              quietZoneColor: 'transparent',
            })   
          } else {
            this.qrCodePrintDrawn.makeCode(this.table.shortUrl)
          }      
  
          this.$refs.html2Pdf.generatePdf()
        } catch (e) {
          console.log('erro:', e)
          this.$emit('downloaded', true)
        }
      },
    },
  }
}
